module.exports = __webpack_public_path__ + "static/media/meetjulia.10c37f8e.mp4";